module.exports = __webpack_public_path__ + "static/media/ITALO.4e8e86fa.svg";